<template>
  <div>
    <p class="title"><span>{{ $t('affiliate') }}</span> > <span>{{ $t('withdrawDetails') }}</span></p>

    <div class="no-record" v-if="records.length === 0 && !loading">{{ $t('noRecords') }}</div>

    <div>
      <div class="phone-records" v-for="item in records">
        <p class="account">{{ item.payment_id }}</p>
        <p>{{ $t('time') }}{{ $t(':') }}{{ item.created_at | createFormatTime(item.created_at) }}</p>
        <p>{{ $t('amount') }}{{ $t(':') }}{{ $t(item.currency_code) }} {{ item[item.currency_code] }}</p>
        <p>{{ $t('status') }}{{ $t(':') }}{{ $t(item.status) }}</p>
      </div>
    </div>

    <spinner :show="loading" class="spinner-component"></spinner>
    <back-to-top></back-to-top>
    <load-more :current-page="currentPage" :total-page="totalPage" :loading="loading" @click.native="queryRecords"></load-more>
  </div>
</template>

<script>
  import locales from './lang'
  import {createFormatTime} from 'src/lib/filters'
  import Spinner from '../Spinner.vue'
  import BackToTop from '../backToTop/BackToTop.vue'
  import LoadMore from '../loadMore/LoadMore.vue'

  export default {
    name: 'withdraw-detail-m',
    components: { Spinner, BackToTop, LoadMore },
    data: function () {
      return {
        records: [],
        totalPage: 1,
        currentPage: 0,
        loading: false
      }
    },
    locales,
    created() {
      this.queryRecords()
    },
    methods: {
      queryRecords() {
        if (this.currentPage > this.totalPage) {
          return
        }
        this.loading = true
        this.currentPage++
        this.$http.get('api/commission-records?type=withdraw', {params: {'page': this.currentPage}}).then((response) => {
          if (response.data.code === 0) {
            this.loading = false
            this.records = this.records.concat(response.data.data)
            this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
          }
        }, response => {
          this.loading = false
        })
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
    letter-spacing: 0;
  }

  .no-record {
    text-align: center;
    line-height: .16rem;
    color: #666;
    padding: .4rem 0;
    font-size: .12rem;
  }

  .title {
    height: .44rem;
    line-height: .44rem;
    padding: 0 .16rem;
    font-size: .14rem;
    color: #111;
    border-bottom: 1px solid #E0D7E3;
    border-radius: 0;
  }

  .phone-records {
    margin: 0 .16rem;
    padding: .16rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid #E0D7E3;
    }
    p {
      line-height: .2rem;
      color:#333;
      &:nth-child(n+2) {
        margin-top: .12rem;
      }
    }
  }

  .spinner-component {
    margin-bottom: .1rem;
  }
</style>



// WEBPACK FOOTER //
// withdrawDetailsM.vue?53090359